import { addZeroPadding, removeZeroPadding } from '@common/neo.tax';
import { MonthDatePicker } from '@ui-components/neo.tax';
import { useState } from 'react';

import { MonthDatePickerFormType } from './forms.types';

export const MonthDatePickerForm = ({ form }: { form: MonthDatePickerFormType }): React.ReactElement | null => {
  const monthAndDateValues = form.value.split('-');
  const monthValue = monthAndDateValues[0];
  const dateValue = monthAndDateValues[1];
  const [month, setMonth] = useState<string>(
    !monthValue || monthValue.length === 0 ? '' : removeZeroPadding(monthValue),
  );
  const [date, setDate] = useState<string>(!dateValue || dateValue.length === 0 ? '' : removeZeroPadding(dateValue));

  const setDateAndSubmit = (dateValue: string): void => {
    setDate(dateValue);
    if (dateValue === '') {
      return;
    }
    form.onChange(addZeroPadding(month) + '-' + addZeroPadding(dateValue));
  };
  return (
    <MonthDatePicker
      monthValue={month}
      monthDateValue={date}
      monthDateLabel={form.monthDateLabel}
      monthLabel={form.monthLabel}
      monthDatePlaceholder={form.monthDatePlaceholder}
      monthPlaceholder={form.monthPlaceholder}
      monthHelpText={form.monthHelpText}
      monthDateHelpText={form.monthDateHelpText}
      monthId={`month-select-${form.id}`}
      monthDateId={`month-date-select-${form.id}`}
      monthDisabled={form.monthDisabled}
      monthDateDisabled={form.monthDateDisabled}
      usePortal // Need to use portal in forms to prevent shift in position of elements
      onChangeMonth={(value: string): void => setMonth(value)}
      onChangeMonthDate={(value: string): void => setDateAndSubmit(value)}
    />
  );
};
